export default {"src":"/_next/static/media/logo-kvinnehelsealliansen.07831275.svg","height":435,"width":1473,"blurWidth":0,"blurHeight":0};